import { lazy } from 'react'

export const EmailVariant2 = lazy(() => import('./EmailVariant2'))
